export default {"src":"/_next/static/media/pythonDjangoIcon.f8ff36cd.svg","height":32,"width":32};